import { createFileRoute, redirect } from '@tanstack/react-router'
import { ProductListView } from '@/features/products/products'
import { hasGrant } from '@/lib/me'

export const Route = createFileRoute('/_authenticated/products/')({
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'product.view')) {
      throw redirect({ to: '/' })
    }
  },
  component: ProductListView,
})
